import { Box, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'

interface Props {
  label: string
  valueLabel: string
  onClick: (e: React.MouseEvent<HTMLElement>) => void
  onClear?: () => void
}

export function SearchFilterChip({ label, valueLabel, onClick, onClear }: Props) {
  const [hovered, setHovered] = useState(false)

  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px',
        px: 1,
        py: 0.25,
        cursor: 'pointer',
        gap: 0.5,
        userSelect: 'none',
        transition: 'background 0.1s',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.8 }}>
        {label}:
      </Typography>
      <Typography variant="caption" sx={{ lineHeight: 1.8 }}>
        {valueLabel}
      </Typography>
      {onClear && (
        <Box
          component="span"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation()
            onClear()
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            opacity: hovered ? 1 : 0,
            transition: 'opacity 0.12s ease',
            cursor: 'pointer',
            ml: 0.25,
          }}
        >
          <CloseIcon sx={{ fontSize: 11 }} />
        </Box>
      )}
    </Box>
  )
}
